import { Subscribable, Subscription } from '@benzinga/subscribable';
import { Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { InvestorsRequest } from './request';
import { InvestorsResponse, NasdaqPrivateMarketListResponse, NasdaqPrivateMarketPricingResponse } from './entities';

interface InvestorsEvent {
  error?: unknown;
  type: 'investors:error';
}

export class InvestorsManager extends Subscribable<InvestorsEvent> {
  private request: InvestorsRequest;
  private restfulSubscription?: Subscription<InvestorsRequest>;

  constructor(session: Session) {
    super();
    this.request = new InvestorsRequest(session);
  }

  public static getName = () => 'benzinga-investors';

  public getCompanies = (symbol: string): SafePromise<NasdaqPrivateMarketListResponse> => {
    return this.request.getCompanies(symbol);
  };

  public getFunding = (symbol: string): SafePromise<NasdaqPrivateMarketListResponse> => {
    return this.request.getFunding(symbol);
  };

  public getInvestors = (symbol: string): SafePromise<InvestorsResponse> => {
    return this.request.getInvestors(symbol);
  };

  public getManagement = (symbol: string): SafePromise<NasdaqPrivateMarketListResponse> => {
    return this.request.getManagement(symbol);
  };

  public getPricing = (symbol: string): SafePromise<NasdaqPrivateMarketPricingResponse> => {
    return this.request.getPricing(symbol);
  };

  protected override onFirstSubscription(): void {
    this.restfulSubscription = this.request.listen(event => this.dispatch(event));
  }

  protected override onZeroSubscriptions(): void {
    this.restfulSubscription?.unsubscribe();
  }
}
